$(document).on('turbolinks:request-start', function() {
    $('#loading-indicator').removeClass('d-none');
});

$(document).on('turbolinks:load', function() {
    $('#loading-indicator').addClass('d-none');

    $('.search-form').on('submit', function() {
        $('#loading-indicator').removeClass('d-none');
    });
});

$(document).ajaxStart(function() {
    $('#loading-indicator').removeClass('d-none');
});

$(document).ajaxStop(function() {
    $('#loading-indicator').addClass('d-none');
});
